import { Injectable, inject } from '@angular/core';

import { HttpCoreService } from '@dataclouder/ngx-core';

const Endpoints = {
  courses: 'api/courses',
};

@Injectable({
  providedIn: 'root',
})
export class CoursesService {
  private httpCoreService: HttpCoreService = inject(HttpCoreService);

  // Not sure how to implement this yet.

  public getCourses() {
    return this.httpCoreService.get(Endpoints.courses);
  }
}
